<script setup lang="ts">
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import ReactRootComponent from '@/components/React/react-root-component.vue'
import Subscription from './Subscription.vue'

const store = useStore()
const route = useRoute()

const useReactSubscription = computed(() => store.getters.user_has_flag('REACT_PAYMENT_GATES'))
</script>

<template>
  <ReactRootComponent
    v-if="useReactSubscription && route.fullPath.includes('/payment-gate')"
    style="height: 100svh"
  />
  <Subscription v-else />
</template>
